import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';
import fonts from '../../../../utils/Fonts';

const HorizontalScrollerElementFields = {
  group: ELEMENT_GROUPS.OTHER,
  label: 'Horizontal Scroller',
  icon: 'DocumentTextIcon',
  description: 'Adds a horizontal scroller',
  properties: [
    'layout',
    {
      label: 'Action',
      name: 'action',
      editor: 'dropdown',
      default: '',
      description:
        'An action to run when an element in the scroller is clicked',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Background Color',
      name: 'backgroundColor',
      editor: 'color',
      description: 'The background color of the control',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Item Background Color',
      name: 'itemBackgroundColor',
      editor: 'color',
      description: 'The background color of each item',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Selected Item Background Color',
      name: 'selectedItemBackgroundColor',
      editor: 'color',
      description: 'The background color of the selected item',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Border Color',
      name: 'borderColor',
      editor: 'color',
      description: 'The border color of the control',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Item Border Color',
      name: 'itemBorderColor',
      editor: 'color',
      description: 'The border color of each item',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Item Border Width',
      name: 'itemBorderWidth',
      editor: 'number',
      description: 'The border width around each item',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Item Border Radius',
      name: 'itemBorderRadius',
      editor: 'number',
      description: 'The border radius of each list item',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Width',
      name: 'borderWidth',
      editor: 'number',
      description: 'The border width around the control',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Border Radius',
      name: 'borderRadius',
      editor: 'number',
      description: 'The border radius of the element',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'titleFont',
      label: 'Title Font Settings',
      description: '',
      editor: 'fontsize',
      type: 'font',
      default: 16,
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Title Font Family',
      name: 'titleFontFamily',
      editor: 'dropdown',
      type: 'string',
      options: [{ label: '<Not Set>', value: '' }, ...fonts],
      description: 'Customise the title font for each item',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      name: 'subTitleFont',
      label: 'Sub-Title Font Settings',
      description: '',
      editor: 'fontsize',
      type: 'font',
      default: 16,
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Sub-Title Font Family',
      name: 'subTitleFontFamily',
      editor: 'dropdown',
      type: 'string',
      options: [{ label: '<Not Set>', value: '' }, ...fonts],
      description: 'Customise the sub-title font family for the list',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    'alignment',
    {
      label: 'Title Alignment',
      name: 'titleAlignment',
      editor: 'alignment',
      description: 'The alignment of the title within each item',
      default: '',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Title Padding',
      name: 'titlePadding',
      editor: 'boundary',
      description: 'The padding around the title of each list item',
      default: '5 5 5 5',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Title Margin',
      name: 'titleMargin',
      editor: 'boundary',
      description: 'The margin around the title of each list item',
      default: '5 5 5 5',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Title Color',
      name: 'titleColor',
      editor: 'color',
      description: 'The color of each item title',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Selected Item Title Color',
      name: 'selectedItemTitleColor',
      editor: 'color',
      description: 'The color of the title on a selected item',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Sub-Title Alignment',
      name: 'subTitleAlignment',
      editor: 'alignment',
      description: 'The alignment of the sub-title within each item',
      default: '',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Sub-Title Padding',
      name: 'subTitlePadding',
      editor: 'boundary',
      description: 'The padding around the sub-title of each list item',
      default: '5 5 5 5',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Sub-Title Margin',
      name: 'subTitleMargin',
      editor: 'boundary',
      description: 'The margin around the sub-title of each list item',
      default: '5 5 5 5',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Sub-Title Color',
      name: 'subTitleColor',
      editor: 'color',
      description: 'The color of each item sub title',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Selected Item Sub-Title Color',
      name: 'selectedItemSubTitleColor',
      editor: 'color',
      description: 'The color of the sub title on a selected item',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    'margin',
    'padding',
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description: 'Choose a content type this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      displayWhen: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Show Item Titles',
      name: 'titleVisible',
      editor: 'boolean',
      description: 'Shows the title of each item',
      default: true,
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Item Title Field',
      name: 'titleSourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying record that will be used for the title of each item',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        params: ['app.id', 'element.datasourceId']
      },
      displayWhen: [
        {
          field: 'datasourceId',
          operator: 'IS_NOT_EMPTY',
          value: []
        },
        {
          combine: 'AND',
          field: 'titleVisible',
          operator: '=',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Item Title',
      name: 'itemTitle',
      editor: 'textbox',
      description: 'A fixed title for each item',
      default: '',
      displayWhen: [
        {
          field: 'datasourceId',
          operator: 'IS_NOT_EMPTY',
          value: []
        },
        {
          combine: 'AND',
          field: 'titleVisible',
          operator: '=',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Show Item Sub-Title',
      name: 'subTitleVisible',
      editor: 'boolean',
      description: 'Shows the sub-title of each list item',
      default: true,
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Item Sub-Title Field',
      name: 'subTitleSourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying record that will be used for the sub-title for each list item',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },
      displayWhen: [
        {
          field: 'datasourceId',
          operator: 'IS_NOT_EMPTY',
          value: []
        },
        {
          combine: 'AND',
          field: 'subTitleVisible',
          operator: '=',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Item Height',
      name: 'itemHeight',
      editor: 'number',
      description: 'The height of a list item',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Item Width',
      name: 'itemWidth',
      editor: 'number',
      description: 'The width of a list item',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Scroller Height',
      name: 'height',
      editor: 'number',
      description: 'The height of the container',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Item Margin',
      name: 'itemMargin',
      editor: 'boundary',
      description: 'The margin around a list item',
      default: '5 5 5 5',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Item Padding',
      name: 'itemPadding',
      editor: 'boundary',
      description: 'The padding within a list item',
      default: '5 5 5 5',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Item Sub-Title',
      name: 'itemSubTitle',
      editor: 'textbox',
      description: 'A fixed sub-title for each list item',
      default: '',
      displayWhen: [
        {
          field: 'datasourceId',
          operator: 'IS_NOT_EMPTY',
          value: []
        },
        {
          combine: 'AND',
          field: 'subTitleVisible',
          operator: '=',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Show Item Image',
      name: 'itemImageVisible',
      editor: 'boolean',
      description: 'Shows the image in each list item',
      default: true,
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      label: 'Item Image Field',
      name: 'itemImageSourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying record that will be used for the list item image',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },
      displayWhen: [
        {
          field: 'datasourceId',
          operator: 'IS_NOT_EMPTY',
          value: []
        },
        {
          combine: 'AND',
          field: 'itemImageVisible',
          operator: '=',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      label: 'Item Image Circular',
      name: 'itemImageCircular',
      editor: 'switch',
      description: 'Whether to show the list item image as circular',
      default: false,
      displayWhen: [
        {
          field: 'itemImageVisible',
          operator: '=',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    }
  ]
};

export default HorizontalScrollerElementFields;
